import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            textAlign: 'center',
            background: 'var(--bg-primary, #0d0d0d)',
            color: 'var(--text-primary, #e6e6e6)',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <h1 style={{ marginBottom: 8, fontSize: '1.25rem' }}>
            Something went wrong
          </h1>
          <p style={{ marginBottom: 24, opacity: 0.8 }}>
            Please try again or return to the home page.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              type="button"
              onClick={this.handleRetry}
              style={{
                padding: '10px 20px',
                fontSize: '1rem',
                cursor: 'pointer',
                background: 'var(--accent, #c9a227)',
                color: '#000',
                border: 'none',
                borderRadius: 4,
              }}
            >
              Try again
            </button>
            <a
              href="/"
              style={{
                padding: '10px 20px',
                fontSize: '1rem',
                color: 'var(--accent, #c9a227)',
                textDecoration: 'underline',
              }}
            >
              Go to home
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
